import { render, staticRenderFns } from "./Fondeos.vue?vue&type=template&id=241688e4&"
import script from "./Fondeos.vue?vue&type=script&lang=js&"
export * from "./Fondeos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports